<template style="height: 100%">
  <article class="message sideMenu">
    <div class="message-body" style="height: 100%">
      <div class="has-text-right">
        <button class="delete" aria-label="delete" v-on:click="close"></button>
      </div>
      <!-- First part -->
      <div class="has-text-centered">
        <!-- Title -->
        <div
          class="heading is-size-6 border"
          style="padding-top: 5px; margin-top: 15px; text-transform: capitalize;"
        >
          <!-- Text -->
          <div class="is-size-2">
            {{
              Object.keys(updateData).length ? "Actualizar" : "Crear Empresa"
            }}
          </div>
        </div>
      </div>
      <br />
      <div>
        <span
          v-if="errors.general.message"
          class="is-size-7 has-text-danger"
          style="margin-top: -5px"
          >{{ errors.general.message }}</span
        >
        <br />
        <!-- Img - Name -->
        <div class="is-flex" style="align-items: end;">
          <div class="upload-image" style="margin-right: 10px;">
            <figure class="image is-96x96" v-on:click="triggerFileInput">
              <img
                :src="
                  imageCompany ||
                    'https://versions.bulma.io/0.7.4/images/placeholders/96x96.png'
                "
                class="image is-96x96"
              />
              <i class="material-icons">upload</i>
            </figure>
            <input
              type="file"
              ref="fileInput"
              style="display: none;"
              v-on:change="onFileChange"
              accept="image/*"
            />
          </div>
          <div style="width: 100%;">
            <label for="name"
              >Razón social<span class="has-text-dark has-text-weight-bold"
                >*</span
              ></label
            >
            <div class="field">
              <div class="control">
                <input
                  class="input"
                  :class="errors.name.type || ''"
                  v-model="company.name"
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Razón social"
                />
              </div>
            </div>
            <span
              v-if="errors.name.message"
              class="is-size-7 has-text-danger"
              style="margin-top: -5px"
              >{{ errors.name.message }}</span
            >
          </div>
        </div>
        <br />
        <!-- NIT -->
        <div>
          <label for="nit"
            >NIT<span class="has-text-dark has-text-weight-bold">*</span></label
          >
          <div class="field">
            <div class="control">
              <input
                class="input"
                :class="errors.nit.type || ''"
                v-model="company.nit"
                type="text"
                id="nit"
                name="nit"
                placeholder="Nit de la empresa"
              />
            </div>
          </div>
          <span
            v-if="errors.nit.message"
            class="is-size-7 has-text-danger"
            style="margin-top: -5px"
            >{{ errors.nit.message }}</span
          >
        </div>
        <br />
        <!-- Economic Sector -->
        <div>
          <label for="economicSector"
            >Sector económico<span class="has-text-dark has-text-weight-bold"
              >*</span
            ></label
          >
          <div class="field">
            <div class="control">
              <div
                class="select is-fullwidth"
                :class="errors.economicSector.type || ''"
              >
                <select
                  :class="{ selectPlaceholder: !company.economicSector }"
                  v-model="company.economicSector"
                  id="economicSector"
                  name="economicSector"
                >
                  <option selected :value="null">Selecciona una opción</option>
                  <option
                    v-for="(v, k) in economicSectors"
                    :key="k"
                    :value="v.value"
                    >{{ v.text }}</option
                  >
                </select>
              </div>
            </div>
          </div>
          <span
            v-if="errors.economicSector.message"
            class="is-size-7 has-text-danger"
            style="margin-top: -5px"
            >{{ errors.economicSector.message }}</span
          >
        </div>
        <br />
        <!-- Number of Employees -->
        <div>
          <label for="numberEmployees"
            >Número de empleados<span class="has-text-dark has-text-weight-bold"
              >*</span
            ></label
          >
          <div class="field">
            <div class="control">
              <div
                class="select is-fullwidth"
                :class="errors.numberEmployees.type || ''"
              >
                <select
                  :class="{ selectPlaceholder: !company.numberEmployees }"
                  v-model="company.numberEmployees"
                  id="numberEmployees"
                  name="numberEmployees"
                >
                  <option selected :value="null">Selecciona una opción</option>
                  <option
                    v-for="(v, k) in numberEmployees"
                    :key="k"
                    :value="v.value"
                    >{{ v.text }}</option
                  >
                </select>
              </div>
            </div>
          </div>
          <span
            v-if="errors.numberEmployees.message"
            class="is-size-7 has-text-danger"
            style="margin-top: -5px"
            >{{ errors.numberEmployees.message }}</span
          >
        </div>
        <br />
        <!-- Type of Capital -->
        <div>
          <label for="typeCapital"
            >Tipo de capital<span class="has-text-dark has-text-weight-bold"
              >*</span
            ></label
          >
          <div class="field">
            <div class="control">
              <div
                class="select is-fullwidth"
                :class="errors.typeCapital.type || ''"
              >
                <select
                  :class="{ selectPlaceholder: !company.typeCapital }"
                  v-model="company.typeCapital"
                  id="typeCapital"
                  name="typeCapital"
                >
                  <option selected :value="null">Selecciona una opción</option>
                  <option
                    v-for="(v, k) in typeCapitals"
                    :key="k"
                    :value="v.value"
                    >{{ v.text }}</option
                  >
                </select>
              </div>
            </div>
          </div>
          <span
            v-if="errors.typeCapital.message"
            class="is-size-7 has-text-danger"
            style="margin-top: -5px"
            >{{ errors.typeCapital.message }}</span
          >
        </div>
        <br />
        <!-- Country -->
        <div>
          <label for="country"
            >País<span class="has-text-dark has-text-weight-bold"
              >*</span
            ></label
          >
          <div class="field">
            <div class="control">
              <div
                class="select is-fullwidth"
                :class="errors.country.type || ''"
              >
                <select
                  :class="{ selectPlaceholder: !company.country }"
                  v-model="company.country"
                  id="country"
                  name="country"
                >
                  <option selected :value="null">Selecciona una opción</option>
                  <option
                    v-for="(v, k) in countrys"
                    :key="k"
                    :value="v.value"
                    >{{ v.text }}</option
                  >
                </select>
              </div>
            </div>
          </div>
          <span
            v-if="errors.country.message"
            class="is-size-7 has-text-danger"
            style="margin-top: -5px"
            >{{ errors.country.message }}</span
          >
        </div>
        <br v-if="company.country === 'CO'" />
        <!-- Departments only in Colombia -->
        <div v-if="company.country === 'CO'">
          <label for="department"
            >Departamento<span class="has-text-dark has-text-weight-bold"
              >*</span
            ></label
          >
          <div class="field">
            <div class="control">
              <div
                class="select is-fullwidth"
                :class="errors.department.type || ''"
              >
                <select
                  :class="{ selectPlaceholder: !company.department }"
                  v-model="company.department"
                  id="department"
                  name="department"
                >
                  <option selected :value="null">Selecciona una opción</option>
                  <option
                    v-for="(v, k) in departmentCO"
                    :key="k"
                    :value="v.value"
                    >{{ v.text }}</option
                  >
                </select>
              </div>
            </div>
          </div>
          <span
            v-if="errors.department.message"
            class="is-size-7 has-text-danger"
            style="margin-top: -5px"
            >{{ errors.department.message }}</span
          >
        </div>
        <br />
        <!-- CIIU -->
        <div>
          <label for="ciiu"
            >CIIU<span class="has-text-dark has-text-weight-bold"
              >*</span
            ></label
          >
          <div class="field">
            <div class="control">
              <div class="select is-fullwidth" :class="errors.ciiu.type || ''">
                <select
                  :class="{ selectPlaceholder: !company.ciiu }"
                  v-model="company.ciiu"
                  id="ciiu"
                  name="ciiu"
                >
                  <option selected :value="null">Selecciona una opción</option>
                  <option v-for="(v, k) in ciius" :key="k" :value="v.value">{{
                    v.text
                  }}</option>
                </select>
              </div>
            </div>
          </div>
          <span
            v-if="errors.ciiu.message"
            class="is-size-7 has-text-danger"
            style="margin-top: -5px"
            >{{ errors.ciiu.message }}</span
          >
        </div>
        <br />
        <!-- Address -->
        <div>
          <label for="address">Dirección </label>
          <div class="field">
            <div class="control">
              <input
                class="input"
                :class="errors.address.type || ''"
                v-model="company.address"
                type="text"
                id="address"
                name="address"
                placeholder="Dirección de la empresa"
              />
            </div>
          </div>
          <span
            v-if="errors.address.message"
            class="is-size-7 has-text-danger"
            style="margin-top: -5px"
            >{{ errors.address.message }}</span
          >
        </div>
        <br />
        <!-- Phone -->
        <div>
          <label for="phone">Teléfono </label>
          <div class="field">
            <div class="control">
              <input
                class="input"
                :class="errors.phone.type || ''"
                v-model="company.phone"
                type="text"
                id="phone"
                name="phone"
                placeholder="Teléfono de la empresa"
              />
            </div>
            <span
              v-if="errors.phone.message"
              class="is-size-7 has-text-danger"
              style="margin-top: -5px"
              >{{ errors.phone.message }}</span
            >
          </div>
        </div>
        <br /><br /><br />
        <!-- Buttons -->
        <div
          class="has-background-white"
          style="position: fixed; bottom: 0; padding-bottom: 10px; width: 100%;"
        >
          <div class="is-flex">
            <button
              class="button is-danger is-outlined"
              style="margin-right: 5px"
              v-on:click="close"
            >
              Cancelar
            </button>
            <button
              class="button is-dark"
              :disable="disableButton"
              v-on:click="saveCompany"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import apiServices from "@/services/yungol-services";

export default {
  data() {
    return {
      company: {
        name: "",
        nit: "",
        address: "",
        phone: "",
        economicSector: null,
        numberEmployees: null,
        typeCapital: null,
        country: null,
        department: null,
        ciiu: null,
      },
      errors: {
        name: {},
        nit: {},
        address: {},
        economicSector: {},
        numberEmployees: {},
        typeCapital: {},
        country: {},
        department: {},
        ciiu: {},
        phone: {},
        general: {}, // Un mensaje de error general
      },
      errorsCont: 0,
      disableButton: true,
      imageCompany: null,
      imageFile: null,
      maxSizeFile: 1 * 1024 * 1024, //  1MB
      // Data
      economicSectors: [
        {
          value: "Comercial",
          text: "Comercial",
        },
        {
          value: "Educativo",
          text: "Educativo",
        },
        {
          value: "Financiero",
          text: "Financiero",
        },
        {
          value: "Industrial",
          text: "Industrial",
        },
        {
          value: "Salud",
          text: "Salud",
        },
        {
          value: "Servicios",
          text: "Servicios",
        },
        {
          value: "Construccion",
          text: "Construcción",
        },
        {
          value: "Agropecuario",
          text: "Agropecuario",
        },
        {
          value: "Energia-Mineria",
          text: "Energía y Minería",
        },
        {
          value: "Transporte",
          text: "Transporte",
        },
        {
          value: "Otros",
          text: "Otros",
        },
      ],
      numberEmployees: [
        {
          value: "1-100",
          text: "De 1 a 100 empleados",
        },
        {
          value: "101-250",
          text: "De 101 a 250 empleados",
        },
        {
          value: "251-500",
          text: "De 251 a 500 empleados",
        },
        {
          value: "500-1000",
          text: "De 501 a 1000 empleados",
        },
        {
          value: "+1000",
          text: "Más de 1000 empleados",
        },
      ],
      typeCapitals: [
        {
          value: "Privado",
          text: "Privado",
        },
        {
          value: "Publico",
          text: "Público",
        },
        {
          value: "Publico/Privado",
          text: "Público/Privado",
        },
      ],
      countrys: [
        { value: "CO", text: "Colombia" },
        { value: "AR", text: "Argentina" },
        { value: "BO", text: "Bolivia" },
        { value: "CL", text: "Chile" },
        { value: "CU", text: "Cuba" },
        { value: "DO", text: "República Dominicana" },
        { value: "EC", text: "Ecuador" },
        { value: "SV", text: "El Salvador" },
        { value: "GT", text: "Guatemala" },
        { value: "HN", text: "Honduras" },
        { value: "MX", text: "México" },
        { value: "NI", text: "Nicaragua" },
        { value: "PA", text: "Panamá" },
        { value: "PY", text: "Paraguay" },
        { value: "PE", text: "Perú" },
        { value: "PR", text: "Puerto Rico" },
        { value: "ES", text: "España" },
        { value: "UY", text: "Uruguay" },
        { value: "VE", text: "Venezuela" },
        { value: "AF", text: "Afganistán" },
        { value: "AL", text: "Albania" },
        { value: "DZ", text: "Argelia" },
        { value: "AS", text: "Samoa Americana" },
        { value: "AD", text: "Andorra" },
        { value: "AO", text: "Angola" },
        { value: "AI", text: "Anguila" },
        { value: "AQ", text: "Antártida" },
        { value: "AG", text: "Antigua y Barbuda" },
        { value: "AZ", text: "Azerbaiyán" },
        { value: "BS", text: "Bahamas" },
        { value: "BH", text: "Baréin" },
        { value: "BD", text: "Bangladés" },
        { value: "BB", text: "Barbados" },
        { value: "BY", text: "Bielorrusia" },
        { value: "BE", text: "Bélgica" },
        { value: "BZ", text: "Belice" },
        { value: "BJ", text: "Benín" },
        { value: "BM", text: "Bermudas" },
        { value: "BT", text: "Bután" },
        { value: "BW", text: "Botsuana" },
        { value: "BR", text: "Brasil" },
        { value: "BN", text: "Brunéi" },
        { value: "BG", text: "Bulgaria" },
        { value: "BF", text: "Burkina Faso" },
        { value: "BI", text: "Burundi" },
        { value: "KH", text: "Camboya" },
        { value: "CM", text: "Camerún" },
        { value: "CA", text: "Canadá" },
        { value: "CV", text: "Cabo Verde" },
        { value: "CF", text: "República Centroafricana" },
        { value: "TD", text: "Chad" },
        { value: "CN", text: "China" },
        { value: "CY", text: "Chipre" },
        { value: "CX", text: "Isla de Navidad" },
        { value: "CC", text: "Islas Cocos (Keeling)" },
        { value: "KM", text: "Comoras" },
        { value: "CG", text: "República del Congo" },
        { value: "CK", text: "Islas Cook" },
        { value: "CR", text: "Costa Rica" },
        { value: "CI", text: "Costa de Marfil" },
        { value: "HR", text: "Croacia" },
        { value: "CU", text: "Cuba" },
        { value: "CW", text: "Curaçao" },
        { value: "DK", text: "Dinamarca" },
        { value: "DJ", text: "Yibuti" },
        { value: "DM", text: "Dominica" },
        { value: "EG", text: "Egipto" },
        { value: "GQ", text: "Guinea Ecuatorial" },
        { value: "ER", text: "Eritrea" },
        { value: "EE", text: "Estonia" },
        { value: "ET", text: "Etiopía" },
        { value: "FJ", text: "Fiyi" },
        { value: "FI", text: "Finlandia" },
        { value: "FR", text: "Francia" },
        { value: "GF", text: "Guayana Francesa" },
        { value: "PF", text: "Polinesia Francesa" },
        { value: "GA", text: "Gabón" },
        { value: "GM", text: "Gambia" },
        { value: "GE", text: "Georgia" },
        { value: "DE", text: "Alemania" },
        { value: "GH", text: "Ghana" },
        { value: "GI", text: "Gibraltar" },
        { value: "GR", text: "Grecia" },
        { value: "GL", text: "Groenlandia" },
        { value: "GD", text: "Grenada" },
        { value: "GP", text: "Guadalupe" },
        { value: "GU", text: "Guam" },
        { value: "GN", text: "Guinea" },
        { value: "GW", text: "Guinea-Bisáu" },
        { value: "GY", text: "Guyana" },
        { value: "HT", text: "Haití" },
        { value: "HK", text: "Hong Kong" },
        { value: "HU", text: "Hungría" },
        { value: "IS", text: "Islandia" },
        { value: "IN", text: "India" },
        { value: "ID", text: "Indonesia" },
        { value: "IR", text: "Irán" },
        { value: "IQ", text: "Irak" },
        { value: "IE", text: "Irlanda" },
        { value: "IL", text: "Israel" },
        { value: "IT", text: "Italia" },
        { value: "JM", text: "Jamaica" },
        { value: "JP", text: "Japón" },
        { value: "JO", text: "Jordania" },
        { value: "KZ", text: "Kazajstán" },
        { value: "KE", text: "Ken ia" },
        { value: "KI", text: "Kiribati" },
        { value: "KP", text: "Corea del Norte" },
        { value: "KR", text: "Corea del Sur" },
        { value: "KW", text: "Kuwait" },
        { value: "KG", text: "Kirguistán" },
        { value: "LA", text: "Laos" },
        { value: "LV", text: "Letonia" },
        { value: "LB", text: "Líbano" },
        { value: "LS", text: "Lesoto" },
        { value: "LR", text: "Liberia" },
        { value: "LY", text: "Libia" },
        { value: "LT", text: "Lituania" },
        { value: "LU", text: "Luxemburgo" },
        { value: "MO", text: "Macao" },
        { value: "MK", text: "Macedonia del Norte" },
        { value: "MG", text: "Madagascar" },
        { value: "MW", text: "Malaui" },
        { value: "MY", text: "Malasia" },
        { value: "MV", text: "Maldivas" },
        { value: "ML", text: "Mali" },
        { value: "MT", text: "Malta" },
        { value: "MH", text: "Islas Marshall" },
        { value: "MQ", text: "Martinica" },
        { value: "MR", text: "Mauritania" },
        { value: "MU", text: "Mauricio" },
        { value: "YT", text: "Mayotte" },
        { value: "FM", text: "Micronesia" },
        { value: "MD", text: "Moldavia" },
        { value: "MC", text: "Mónaco" },
        { value: "MN", text: "Mongolia" },
        { value: "ME", text: "Montenegro" },
        { value: "MS", text: "Montserrat" },
        { value: "MA", text: "Marruecos" },
        { value: "MZ", text: "Mozambique" },
        { value: "MM", text: "Myanmar (Birmania)" },
        { value: "NA", text: "Namibia" },
        { value: "NR", text: "Nauru" },
        { value: "NP", text: "Nepal" },
        { value: "NL", text: "Países Bajos" },
        { value: "NC", text: "Nueva Caledonia" },
        { value: "NZ", text: "Nueva Zelanda" },
        { value: "NE", text: "Níger" },
        { value: "NG", text: "Nigeria" },
        { value: "NU", text: "Niue" },
        { value: "NF", text: "Isla Norfolk" },
        { value: "MP", text: "Islas Marianas del Norte" },
        { value: "NO", text: "Noruega" },
        { value: "OM", text: "Omán" },
        { value: "PK", text: "Pakistán" },
        { value: "PW", text: "Palaos" },
        { value: "PS", text: "Palestina" },
        { value: "PG", text: "Papúa Nueva Guinea" },
        { value: "PH", text: "Filipinas" },
        { value: "PN", text: "Islas Pitcairn" },
        { value: "PL", text: "Polonia" },
        { value: "PT", text: "Portugal" },
        { value: "QA", text: "Catar" },
        { value: "RE", text: "Reunión" },
        { value: "RO", text: "Rumania" },
        { value: "RU", text: "Rusia" },
        { value: "RW", text: "Ruanda" },
        { value: "SH", text: "Santa Helena, Ascensión y Tristán de Acuña" },
        { value: "KN", text: "San Cristóbal y Nieves" },
        { value: "LC", text: "Santa Lucía" },
        { value: "VC", text: "San Vicente y las Granadinas" },
        { value: "WS", text: "Samoa" },
        { value: "SM", text: "San Marino" },
        { value: "ST", text: "Santo Tomé y Príncipe" },
        { value: "SA", text: "Arabia Saudita" },
        { value: "SN", text: "Senegal" },
        { value: "RS", text: "Serbia" },
        { value: "SC", text: "Seychelles" },
        { value: "SL", text: "Sierra Leona" },
        { value: "SG", text: "Singapur" },
        { value: "SX", text: "Sint Maarten" },
        { value: "SK", text: "Eslovaquia" },
        { value: "SI", text: "Eslovenia" },
        { value: "SB", text: "Islas Salomón" },
        { value: "SO", text: "Somalia" },
        { value: "ZA", text: "Sudáfrica" },
        { value: "SS", text: "Sudán del Sur" },
        { value: "LK", text: "Sri Lanka" },
        { value: "SD", text: "Sudán" },
        { value: "SR", text: "Surinam" },
        { value: "SJ", text: "Svalbard y Jan Mayen" },
        { value: "SZ", text: "Suazilandia" },
        { value: "SE", text: "Suecia" },
        { value: "CH", text: "Suiza" },
        { value: "SY", text: "Siria" },
        { value: "TW", text: " Taiwán" },
        { value: "TJ", text: "Tayikistán" },
        { value: "TZ", text: "Tanzania" },
        { value: "TH", text: "Tailandia" },
        { value: "TL", text: "Timor Oriental" },
        { value: "TG", text: "Togo" },
        { value: "TK", text: "Tokelau" },
        { value: "TO", text: "Tonga" },
        { value: "TT", text: "Trinidad y Tobago" },
        { value: "TN", text: "Túnez" },
        { value: "TR", text: "Turquía" },
        { value: "TM", text: "Turkmenistán" },
        { value: "TC", text: "Islas Turcas y Caicos" },
        { value: "TV", text: "Tuvalu" },
        { value: "UG", text: "Uganda" },
        { value: "UA", text: "Ucrania" },
        { value: "AE", text: "Emiratos Árabes Unidos" },
        { value: "GB", text: "Reino Unido" },
        { value: "US", text: "Estados Unidos" },
        { value: "UZ", text: "Uzbekistán" },
        { value: "VU", text: "Vanuatu" },
        { value: "VA", text: "Ciudad del Vaticano" },
        { value: "VN", text: "Vietnam" },
        { value: "VG", text: "Islas Vírgenes Británicas" },
        { value: "VI", text: "Islas Vírgenes de los Estados Unidos" },
        { value: "WF", text: "Wallis y Futuna" },
        { value: "YE", text: "Yemen" },
        { value: "ZM", text: "Zambia" },
        { value: "ZW", text: "Zimbabue" },
      ],
      departmentCO: [
        { value: "AMA", text: "Amazonas" },
        { value: "ANT", text: "Antioquia" },
        { value: "ARA", text: "Arauca" },
        { value: "ATL", text: "Atlántico" },
        { value: "BOL", text: "Bolívar" },
        { value: "BOY", text: "Boyacá" },
        { value: "CAL", text: "Caldas" },
        { value: "CAQ", text: "Caquetá" },
        { value: "CAS", text: "Casanare" },
        { value: "CAU", text: "Cauca" },
        { value: "CES", text: "Cesar" },
        { value: "CHO", text: "Chocó" },
        { value: "CÓR", text: "Córdoba" },
        { value: "CUN", text: "Cundinamarca" },
        { value: "GUAI", text: "Guainía" },
        { value: "GUA", text: "Guaviare" },
        { value: "GUJ", text: "Guajira" },
        { value: "HUI", text: "Huila" },
        { value: "MAG", text: "Magdalena" },
        { value: "META", text: "Meta" },
        { value: "NAR", text: "Nariño" },
        { value: "NDS", text: "Norte de Santander" },
        { value: "PUT", text: "Putumayo" },
        { value: "QUI", text: "Quindío" },
        { value: "RIS", text: "Risaralda" },
        { value: "SAND", text: "San Andrés y Providencia" },
        { value: "SAN", text: "Santander" },
        { value: "SUC", text: "Sucre" },
        { value: "TOL", text: "Tolima" },
        { value: "VAL", text: "Valle del Cauca" },
        { value: "VAS", text: "Vaupés" },
        { value: "VIC", text: "Vichada" },
      ],
      ciius: [
        {
          value: "AGCSP",
          text: "Agricultura, ganadería, caza, silvicultura y pesca",
        },
        {
          value: "APCT",
          text: "Actividades profesionales, científicas y técnicas",
        },
        {
          value: "ASAA",
          text: "Actividades de servicios administrativos y de apoyo",
        },
        {
          value: "AFS",
          text: "Actividades financieras y de seguros",
        },
        {
          value: "AI",
          text: "Actividades inmobiliarias",
        },
        {
          value: "IMF",
          text: "Industrias Manufactureras",
        },
        {
          value: "AAER",
          text: "Actividades artísticas, de entretenimiento y recreación",
        },
        {
          value: "AASHAS",
          text:
            "Actividades de atención de la salud humana y de asistencia social",
        },
        {
          value: "AHCEADHIPBSUP",
          text:
            "Actividades de los hogares en calidad de empleadores; actividades no diferenciadas de los hogares individuales como productores de bienes y servicios para uso propio",
        },
        {
          value: "AOEE",
          text: "Actividades de organizaciones y entidades extraterritoriales",
        },
        {
          value: "ASC",
          text: "Alojamiento y servicios de comida",
        },
        {
          value: "APDPSSAO",
          text:
            "Administración pública y defensa; planes de seguridad social de afiliación obligatoria",
        },
        {
          value: "C",
          text: "Construcción",
        },
        {
          value: "CMMRVAM",
          text:
            "Comercio al por mayor y al por menor; reparación de vehículos automotores y motocicletas",
        },
        {
          value: "DAETGDASA",
          text:
            "Distribución de agua; evacuación y tratamiento de aguas residuales, gestión de desechos y actividades de saneamiento ambiental",
        },
        {
          value: "E",
          text: "Educación",
        },
        {
          value: "EMC",
          text: "Explotación de minas y canteras",
        },
        {
          value: "IC",
          text: "Información y comunicaciones",
        },
        {
          value: "OAS",
          text: "Otras actividades de servicios",
        },
        {
          value: "SEGVAA",
          text: "Suministro de electricidad, gas, vapor, y aire acondicionado",
        },
        {
          value: "TA",
          text: "Transporte y almacenamiento",
        },
      ],
    };
  },
  props: {
    updateData: {
      type: Object,
      default() {
        return null;
      },
    },
    dataValidate: {
      type: Array,
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit("switchSideMenu");
    },
    async saveCompany() {
      let result;
      try {
        if (this.validateForm()) {
          const data = {
            nit: this.company.nit,
            nombre: this.company.name,
            direccion: this.company.address,
            sector: this.company.economicSector, // new
            numberEmployees: this.company.numberEmployees, // new
            typeCapital: this.company.typeCapital, // new
            country: this.company.country, // new
            department: this.company.department, // new
            ciiu: this.company.ciiu, // new
            formas: "",
            telefono: this.company.phone,
            region: "",
            ciudad: "",
            pagina: "",
            numero: "",
            grupo: "",
            riesgo: "",
            encargado: "",
            encargadoP: "",
            descripcion: "",
          };

          if (this.updateData._id) {
            data._id = this.updateData._id;
            result = await apiServices.put(`/updatecompany`, data);
          } else {
            result = await apiServices.post(`/createcompany`, data);
          }

          if (result.data || this.updateData._id) {
            if (this.imageFile) {
              this.saveImgCompany(result.data || this.updateData);
            } else {
              await this.$swal({
                title: this.company.name,
                text: this.updateData._id
                  ? "Se actualizó correctamente."
                  : "Se creó correctamente.",
                icon: "success",
                showConfirmButton: false,
                timer: 1700,
              });
              this.clearAllForm();
              this.close();
              this.$emit("getCompanies");
            }
          }
        }
      } catch (err) {
        console.log(err);
        await this.$swal({
          title: this.company.name,
          text: this.updateData._id
            ? "Error al editar la empresa."
            : "Error al crear la empresa.",
          icon: "danger",
          showConfirmButton: false,
          timer: 1700,
        });
      }
    },
    async saveImgCompany(data) {
      const upload = this.$fire.saveImgCompany(this.imageFile, data._id);

      upload
        .then(async () => {
          await this.$swal({
            title: this.company.name,
            text: this.updateData._id
              ? "Se actualizó correctamente."
              : "Se creó correctamente.",
            icon: "success",
            showConfirmButton: false,
            timer: 1700,
          });
          this.clearAllForm();
          this.close();
          this.$emit("getCompanies");
        })
        .catch((error) => {
          this.$swal({
            text: "Error al cargar la imagen.",
            icon: "error",
            showConfirmButton: false,
            timer: 1700,
          });
          this.imageCompany = null;
          this.imageFile = null;
          console.log(error);
        });
    },
    getImgCompany(id) {
      const imageCompany = this.$fire.getImgCompany(id);
      imageCompany
        .then((result) => {
          this.imageCompany = result;
        })
        .catch((error) => {
          console.log(error);
          /* this.$store.dispatch("notify", {
            message: "Error al obtener los datos",
            type: "is-danger",
            duration: 4000,
            position: "top-center",
          }); */
          this.loading = false;
        });
    },
    validateForm() {
      this.errors = {
        name: {},
        nit: {},
        address: {},
        economicSector: {},
        numberEmployees: {},
        typeCapital: {},
        country: {},
        department: {},
        ciiu: {},
        phone: {},
        general: {},
      };
      const company = this.company;
      const update = this.updateData
        ? {
            nit: this.updateData.nit,
            name: this.updateData.nombre,
            address: this.updateData.direccion,
            economicSector: this.updateData.sector,
            numberEmployees: this.updateData.numberEmployees,
            typeCapital: this.updateData.typeCapital,
            country: this.updateData.country,
            department: this.updateData.department,
            ciiu: this.updateData.ciiu,
            phone: this.updateData.telefono,
          }
        : null;

      let valid = true;

      if (
        update &&
        !this.imageFile &&
        JSON.stringify(company) === JSON.stringify(update)
      ) {
        this.errors.general.message = "Edita algo para guardar.";
        this.errors.general.type = "is-danger";
        valid = false;
      }

      if (company.name === "" || company.name === null) {
        this.errors.name.message = "El nombre es requerido.";
        this.errors.name.type = "is-danger";
        valid = false;
      }

      if (
        this.dataValidate &&
        this.dataValidate.filter(
          (el) =>
            el.nombre === company.name &&
            (!this.updateData || this.updateData._id !== el._id),
        ).length
      ) {
        this.errors.name.message = "El nombre ya esta registrado.";
        this.errors.name.type = "is-danger";
        valid = false;
      }

      if (company.nit === "" || company.nit === null) {
        this.errors.nit.message = "El nit es requerido.";
        this.errors.nit.type = "is-danger";
        valid = false;
      }

      if (
        this.dataValidate &&
        this.dataValidate.filter(
          (el) =>
            el.nit === company.nit &&
            (!this.updateData || this.updateData._id !== el._id),
        ).length
      ) {
        this.errors.nit.message = "El nit ya esta registrado.";
        this.errors.nit.type = "is-danger";
        valid = false;
      }

      if (company.economicSector === "" || company.economicSector === null) {
        this.errors.economicSector.message =
          "El sector económico es requerido.";
        this.errors.economicSector.type = "is-danger";
        valid = false;
      }

      if (company.numberEmployees === "" || company.numberEmployees === null) {
        this.errors.numberEmployees.message =
          "El número de empleados es requerido.";
        this.errors.numberEmployees.type = "is-danger";
        valid = false;
      }

      if (company.typeCapital === "" || company.typeCapital === null) {
        this.errors.typeCapital.message = "El tipo de capital es requerido.";
        this.errors.typeCapital.type = "is-danger";
        valid = false;
      }

      if (company.country === "" || company.country === null) {
        this.errors.country.message = "El país es requerido.";
        this.errors.country.type = "is-danger";
        valid = false;
      }

      if (
        company.country === "CO" &&
        (company.department === "" || company.department === null)
      ) {
        this.errors.department.message = "El departamento es requerido.";
        this.errors.department.type = "is-danger";
        valid = false;
      }

      if (company.ciiu === "" || company.ciiu === null) {
        this.errors.ciiu.message = "El ciiu es requerido.";
        this.errors.ciiu.type = "is-danger";
        valid = false;
      }

      if (!valid) {
        this.errorsCont++;
      }
      console.log(this.errorsCont, valid, this.errors);
      return valid;
    },
    clearAllForm() {
      this.company = {
        name: "",
        nit: "",
        address: "",
        phone: "",
        economicSector: null,
        numberEmployees: null,
        typeCapital: null,
        country: null,
        department: null,
        ciiu: null,
      };

      this.errors = {
        name: {},
        nit: {},
        address: {},
        economicSector: {},
        numberEmployees: {},
        typeCapital: {},
        country: {},
        department: {},
        ciiu: {},
        general: {},
      };
      this.errorsCont = 0;
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.size > this.maxSize) {
          this.errors.general.type = "is-danger";
          return (this.errors.general.message = `El archivo es demasiado grande. Máximo permitido: ${this
            .maxSize /
            (1024 * 1024)} MB.`);
        } else {
          this.errors.general = {};
        }
        this.imageFile = file;

        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageCompany = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click(); // Activa el input de archivo
    },
  },
  created() {},
  watch: {
    company: {
      handler() {
        if (this.errorsCont) {
          if (this.validateForm()) {
            this.disableButton = false;
          } else {
            this.disableButton = true;
          }
        }
        console.log(this.disableButton);
      },
      deep: true,
    },
    updateData: {
      handler() {
        this.company = {
          nit: this.updateData.nit,
          name: this.updateData.nombre,
          address: this.updateData.direccion || null,
          economicSector: this.updateData.sector,
          numberEmployees: this.updateData.numberEmployees || null,
          typeCapital: this.updateData.typeCapital || null,
          country: this.updateData.country || null,
          department: this.updateData.department || null,
          ciiu: this.updateData.ciiu || null,
          phone: this.updateData.telefono || null,
        };
        this.getImgCompany(this.updateData._id);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.upload-image {
  cursor: pointer;
}

.upload-image img {
  border-radius: 6px;
  object-fit: cover;
}

.upload-image:hover figure::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Fondo negro con opacidad */
  z-index: 1;
  border-radius: 6px;
}

.upload-image i {
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2rem;
  color: #fff;
  z-index: 2;
}

.upload-image:hover i {
  opacity: 1;
  background-color: #522687;
  border-radius: 6px;
}
</style>
<style lang="scss">
.sideMenu {
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  @media screen and (min-width: 1280px) {
    width: 30%;
  }
  height: 100%;
  position: fixed;
  background: white;
  z-index: 251;
  top: 0;
  right: 0;
  overflow: scroll;
  border-radius: 0 0 0 0 !important;
}

.sideMenu .field {
  margin-bottom: 0;
}

.selectPlaceholder {
  color: #d5d5d5 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/empresas/components/SideMenu.vue